export default
    {
        // url: this.$store.state.http.trasplantes.YYYY,
        guarda: "/trasplantes/guarda",
        list: "/trasplantes/list",
        printListado: "/trasplantes/printListado",
    }
